export const CODE_KO = 'KO';
export const CODE_OK = 'OK';
export const E0 = '0';
